import {
  APICallState,
  LottieAnimations,
} from '@eCommerce/frontend-legacy-shared-library';
import {StatusType} from 'models/StatusTypes';

export const getOverlayAnimation = (statusType: StatusType | APICallState) => {
  switch (statusType) {
    case StatusType.SUCCESS:
      return LottieAnimations.successAnimation;

    case StatusType.ERROR:
      return LottieAnimations.errorAnimation;

    case StatusType.LOADING:
      return LottieAnimations.loaderAnimation;

    default:
      return LottieAnimations.errorAnimation;
  }
};
